<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <div translate>INSIGHTS.TITLE</div>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" no-bounce>

  <accordion [title]="'INSIGHTS.PERFORMANCE' | translate" [icon]="'bar-chart-outline'" [content]="content">
    <performance-panel #performance></performance-panel>
  </accordion>

  <accordion [title]="'INSIGHTS.RECREATION' | translate" [icon]="'bed-outline'" [content]="content">
    <recreation-panel #recreation></recreation-panel>
  </accordion>

  <accordion [title]="'INSIGHTS.RESILIENCE' | translate" [icon]="'help-circle-outline'" [content]="content">
    <resilience-panel #resilience></resilience-panel>
  </accordion>

</ion-content>
